import React, {
  useState,
  useEffect
} from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { showCoupon } from '~/config/routes';
import Request from '~/providers/Request';
import CouponRecord from '~/records/CouponRecord';
import Form from './Form';
import { toast } from 'react-toastify';
import moment from 'moment';
import ModalAlertAddon from '~/components/Modal/ModalAlert';

function EditRecord({history}){
  const [record, setRecord] = useState(new CouponRecord());
  const [loading, setLoading] = useState(false);
  const [promotionActiveBlock, setPromotionActiveBlock] = useState(false);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id) {
      setLoading(true);
      Request.get(`/admin/coupon/${id}`, {})
        .then((response) => {
          setLoading(false);
          if (response.data.start_date) {
            const todayUnix = moment().unix();
            const startDateUnix = moment(response.data.start_date).unix();
            const diffDates = startDateUnix - todayUnix;
            if (diffDates < 0) {
              setPromotionActiveBlock(true);
            }
          }
          setRecord( record.updateAttributes(response.data) );
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, [promotionActiveBlock]);

  async function onSubmit (saveAndContinue){
    const data = await record.toParams();
    setLoading(true);

    await Request.put(`/admin/coupon/${id}`, data, {}, { controller: 'coupon' })
      .then((resp) => {
        setLoading(false);
        toast.success('Cupom atualizado com sucesso!');
        if(saveAndContinue){
          history.push(showCoupon.reverse(resp.data));
        } else {
          history.push('/coupon');
        }
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  const handleRedirect = () => {
    history.push('/coupon');
  };
  
  return(
    <div>
      <Form
        onSubmit={onSubmit}
        record={record}
        handleChange={handleChange}
        loading={loading}
        setRecord={setRecord}
      />
      <ModalAlertAddon
        modal={promotionActiveBlock}
        onClose={() => setPromotionActiveBlock(false)}
        handle={handleRedirect}
      />
    </div>
  );
}

EditRecord.propTypes={
  history: historyPropType,
};

export default EditRecord;
